import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../page-header';
import '../../components/cartao/StyleCartao.css';
import { ModalLimite } from './cartao-limite-modal/cartao-limite-modal';
import { ModalRequestExtract } from './cartao-RequestExtract-modal/cartao-RequestExtract-modal';
import { ManageCard } from './cartao-manageCard-modal/cartao-manageCard-modal';
import { ModalRequestCard } from './cartao-RequestCard-modal/cartao-RequestCard-modal';
import CardCarousel from '../../pages/pagina-cartao/components/CardsCarousel';
import { ModalUnlockCard } from './cartao-unlockCard-modal/cartao-unlockCard-modal';
import { AiFillCreditCard, AiFillFileText } from 'react-icons/ai';
import { CiDollar } from 'react-icons/ci';
import { IoMdTime } from 'react-icons/io';
import { MdRocketLaunch } from 'react-icons/md';
import { BeatLoader } from 'react-spinners';
import { FaUnlockAlt } from 'react-icons/fa';
import { useCards } from '../../hooks/useCards';

export function PageCard() {
  const [activeModal, setActiveModal] = useState(null);
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const navigate = useNavigate();
  const { cards, selectedCard, setSelectedCard, loading, cardRequests, getCardData, getInvoices, getCardRequests } = useCards();

  const handleButtonClick = (modalType) => {
    setActiveModal(modalType);
  };

  const updateCardIndex = (callback, direction) => {
    if (cards?.length > 1) {
      setDirection(direction);
      setSelectedCardIndex((prevIndex) => callback(prevIndex, cards?.length));
    }
  };

  const handleNextCard = () => {
    updateCardIndex((prevIndex, length) => (prevIndex + 1) % length, 1);
  };

  const handlePrevCard = () => {
    updateCardIndex((prevIndex, length) => (prevIndex === 0 ? length - 1 : prevIndex - 1), -1);
  };

  const handleCloseModal = () => {
    setActiveModal(null);
  };

  const verifyIfCardIsNew = () => {
    return selectedCard && selectedCard.blocked && selectedCard.blockedReason === 'CARTAO_NOVO_SEM_DESBLOQUEIO';
  }

  const renderCardActions = () => {
    if (verifyIfCardIsNew()) {
      return [
        {
          title: 'Desbloquear Cartão',
          icon: <FaUnlockAlt color='white' size={30} />,
          onClick: () => handleButtonClick('Desbloquear Cartão'),
          disabled: false
        }
      ];
    }

    if (!!cards?.length) {
      const card = cards.find((card) => card.cardType === 'debit');

      const isBlockedDebit =
        card?.cardType === 'debit' &&
        card?.blocked &&
        ['CARTAO_ROUBADO', 'CARTAO_PERDIDO', 'CARTAO_INVALIDO'].includes(card?.blockedReason);

      if (isBlockedDebit && cardRequests?.length) return [
        {
          title: 'Já existe uma solicitação de segunda via em andamento',
          icon: <IoMdTime color='white' size={30} />,
          disabled: true
        }
      ];

      const hasCreditCard = cards.some((card) => card.cardType === 'credit');

      const actions = [
        {
          title: 'Meus Limites',
          subTitle: "Visualize e gerencie os limites disponíveis do seu cartão",
          icon: <CiDollar color='white' size={30} />,
          onClick: () => handleButtonClick('Meus Limites'),
          disabled: false
        },
        {
          title: 'Meus Cartões',
          subTitle: "Acesse todos os seus cartões e gerencie suas configurações",
          icon: <AiFillCreditCard color='white' size={30} />,
          onClick: () => handleButtonClick('Meus Cartões'),
          disabled: false
        },
      ];

      if (hasCreditCard) {
        actions.push({
          title: 'Faturas',
          subTitle: "Visualize e pague suas faturas de forma rápida e segura",
          icon: <AiFillFileText color='white' size={30} />,
          onClick: () => navigate("/pagina-cartao/fatura"),
          disabled: false
        });
      }

      return actions;
    }

    if (!cards?.length && !cardRequests?.length) {
      return [{
        title: 'Solicitar novo cartão',
        subTitle: 'Peça agora seu cartão e aproveite todos os benefícios.',
        icon: <MdRocketLaunch color='white' size={30} />,
        onClick: () => handleButtonClick('Solicitar Cartão'),
        disabled: false
      }];
    }

    return [{
      title: 'Já existe uma solicitação de cartão em andamento',
      icon: <IoMdTime color='white' size={30} />,
      disabled: true
    }];
  }

  useEffect(() => {
    getCardData();
    getCardRequests();
  }, []);

  useEffect(() => {
    if (cards?.length) {
      setSelectedCard(cards[selectedCardIndex]);
    }
  }, [cards, selectedCardIndex]);

  const hasNoCards = !loading && !cards?.length;
  const hasPendingRequest = !!cardRequests?.length;

  if (loading) {
    return (
      <div className="card-container">
        <div className="card-page-header">
          <PageHeader title="Cartão" pages={[{ name: 'Cartão', link: '' }]} />
        </div>
        <div className="card-loading-state">
          <div className="card-spinner" />
          <span className="card-loading-text">Carregando...</span>
        </div>
      </div>
    );
  }
  return (
    <>
      {activeModal === 'Meus Limites' &&
        <ModalLimite
          isOpen={true}
          onClose={handleCloseModal}
          card={selectedCard || cards[0]}
          title="Meus Limites"
          fetchCardInfo={getCardData}
        />
      }
      {activeModal === 'Meus Cartões' &&
        <ManageCard
          isOpen={true}
          onClose={handleCloseModal}
          cards={cards}
          getCards={getCardData}
          cardRequests={cardRequests}
          setActiveModal={setActiveModal}
        />
      }
      {activeModal === 'Solicitar Extrato' && <ModalRequestExtract isOpen={true} onClose={handleCloseModal} />}
      {activeModal === 'Solicitar Cartão' && <ModalRequestCard isOpen={true} onClose={handleCloseModal} cardType={"debit"} isFirstCard={!cards?.length} />}
      {activeModal === 'Desbloquear Cartão' && <ModalUnlockCard isOpen={true} onClose={handleCloseModal} card={selectedCard} />}

      <div className="card-container">
        <div className="card-page-header">
          <PageHeader title="Cartão" pages={[{ name: 'Cartão', link: '' }]} />
        </div>

        <div className="card-content">
          {hasNoCards ? (
            <div className="empty-card-state">
              <div className="empty-card-illustration">
                <div
                  className="empty-card-icon-circle"
                  style={{ backgroundColor: 'var(--primary-color)' }}
                >
                  <MdRocketLaunch color="white" size={48} />
                </div>
              </div>
              <h4 className="empty-card-title">Você ainda não possui cartão</h4>
              <p className="empty-card-description">
                Solicite seu cartão para começar a usar os recursos disponíveis.
              </p>

              {!hasPendingRequest ? (
                <button
                  className="btn mt-2 px-4 py-2"
                  style={{
                    backgroundColor: 'var(--primary-color)',
                    borderColor: 'var(--primary-color)',
                    color: '#fff',
                    borderRadius: '10px',
                    fontWeight: 600,
                  }}
                  onClick={() => handleButtonClick('Solicitar Cartão')}
                >
                  Solicitar novo cartão
                </button>
              ) : (
                <div className="mt-3 d-flex align-items-center justify-content-center gap-2">
                  <IoMdTime color="var(--primary-color)" size={22} />
                  <span>Já existe uma solicitação de cartão em andamento</span>
                </div>
              )}
            </div>
          ) : (
            <div className="card-actions">
              <div className='col-md-6 d-flex align-items-center justify-content-center'>
                {
                  cards?.length ? (
                    <CardCarousel
                      selectedCard={selectedCard || cards[0]}
                      selectedCardIndex={selectedCardIndex}
                      direction={direction}
                      handlePrevCard={handlePrevCard}
                      handleNextCard={handleNextCard}
                    />
                  ) : null
                }
              </div>
              <div className="buttons-container col-md-6">
                <div className="d-flex flex-column gap-3 mt-2">
                  {renderCardActions().map((action, index) => (
                    <div
                      className={`card border-0 ${action.disabled ? '' : 'shadow-sm'} h-100 bg-white`}
                      style={{
                        transition: 'all 0.2s ease-in-out',
                        borderRadius: '10px',
                        cursor: action.disabled ? 'default' : 'pointer',
                      }}
                      key={index}
                      onMouseOver={
                        !action.disabled
                          ? (e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.1)';
                          }
                          : undefined
                      }
                      onMouseOut={
                        !action.disabled
                          ? (e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                          }
                          : undefined
                      }
                      onClick={action.onClick}
                      disabled={action.disabled}
                    >
                      <div className="card-body text-center p-4">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                          style={{
                            width: '60px',
                            height: '60px',
                            backgroundColor: 'var(--primary-color)'
                          }}
                        >
                          {action.icon}
                        </div>
                        <h5 className="mb-3">{action.title}</h5>
                        <p className="text-muted small mb-0">{action.subTitle}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
